export const TRANSACTION_REQUEST = "TRANSACTION_REQUEST";
export const TRANSACTION_SUCCESS = "TRANSACTION_SUCCESS";
export const TRANSACTION_FAILED = "TRANSACTION_FAILED";